import React from "react"
import Styles from "./ForHealthCoachFeaturesStyles.module.styl"
import Rocket from "../../../../../assets/images/icon-rocket.svg"
import Like from "../../../../../assets/images/icon-like.svg"
import File from "../../../../../assets/images/icon-opened-file.svg"
import WorkFlow from "../../../../../assets/images/icon-workflow.svg"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const ForHealthCoachFeatures = ({ locale }) => {
  return (
    <div className={Styles.wrapper}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6">
            <div className={Styles.feature}>
              <img src={Rocket} alt="rocket" />
              <div className={Styles.feature_description}>
                <p>{translate(keys.HLTH_COACH_FEAT_NEW_PACI, locale)}</p>
                <p>{translate(keys.HLTH_COACH_FEAT_REACH_WORLD, locale)}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {" "}
            <div className={Styles.feature}>
              <img src={WorkFlow} alt="rocket" />
              <div className={Styles.feature_description}>
                <p>{translate(keys.HLTH_COACH_FEAT_AUTO_WORK, locale)}</p>
                <p>{translate(keys.HLTH_COACH_FEAT_FASTER_BETTER, locale)}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {" "}
            <div className={Styles.feature}>
              <img src={File} alt="rocket" />
              <div className={Styles.feature_description}>
                <p>{translate(keys.HLTH_COACH_FEAT_ONLINE, locale)}</p>
                <p>{translate(keys.HLTH_COACH_FEAT_SCHEDULE, locale)}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {" "}
            <div className={Styles.feature}>
              <img src={Like} alt="rocket" />
              <div className={Styles.feature_description}>
                <p>{translate(keys.HLTH_COACH_FEAT_TRUE_FEEDBACK, locale)}</p>
                <p>{translate(keys.HLTH_COACH_FEAT_RATE, locale)} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForHealthCoachFeatures
